export default {"src":"/_next/static/image/public/images/flags/flag_852.d68c70259d0cd19cf2ba8574375691c5.svg","height":16,"width":24};